module.exports = __webpack_public_path__ + "static/media/RE-empty-open.a97fd237.svg";